import { ReactElement } from 'react';

export interface TranslationProviderProps {
  children?: ReactElement | ReactElement[];
}

export enum CountryCode {
  PL = 'PL',
  RO = 'RO'
}
